{
  "apply-job": {
    "en": "Apply Job",
    "ar": "التقدم للوظيفة",
    "id": "Lamar Pekerjaan"
  },
  "applied": {
    "en": "Applied",
    "ar": "تم التقديم",
    "id": "Sudah Dilamar"
  }
}
